import { Component, Prop, State, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-accordion',
  styleUrls: ['dda-accordion.css', '../../global/global.css',],
  shadow: false,
})
export class DdaAccordion {
  @Prop() design: 'bg-border' | 'no-border' = 'bg-border'; // Default to background and border design
  @Prop() header_text: string = 'Accordion Header'; // Default header text
  @Prop() body_description: string = 'This is the accordion body content.'; // Default body description
  @Prop() custom_class?: string = ''; 
  @Prop() component_mode?: string; 

  @State() isOpen: boolean = false;

  toggleAccordion() {
    this.isOpen = !this.isOpen;
  }

  render() {
    return (
      <Host>
        <div class={`accordion-container ${this.design} ${this.custom_class} ${this.component_mode}`}>
          <div class="accordion-header" onClick={() => this.toggleAccordion()}>
            <div class="header-content">
              <i class="fa fa-info-circle"></i>
              <span class="header-text">{this.header_text}</span>
            </div>
            <i class={`fa ${this.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'} arrow-icon`}></i>
          </div>
          {this.isOpen && (
            <div class="accordion-body">
              <p class="body-description">{this.body_description}</p>
            </div>
          )}
        </div>
      </Host>
    );
  }
}
